import {Component, OnInit} from '@angular/core';
import { IdentityService } from '../../services/identity.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  stats: any = {};

  constructor(private appService: IdentityService) {}

  ngOnInit() {
    this.getStats();
  }

  getStats() {
    this.appService.getStats().subscribe(res => {
      this.stats = res;
    });
  }
}
